module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Lunch_Sunday.f2d15226.jpg";